module.exports = __webpack_public_path__ + "img/治未病.73709619.jpg";